import { render, staticRenderFns } from "./bookings.vue?vue&type=template&id=38b05c2e&scoped=true"
import script from "./bookings.vue?vue&type=script&lang=js"
export * from "./bookings.vue?vue&type=script&lang=js"
import style0 from "./bookings.vue?vue&type=style&index=0&id=38b05c2e&prod&scoped=true&lang=css"
import style1 from "./bookings.vue?vue&type=style&index=1&id=38b05c2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b05c2e",
  null
  
)

export default component.exports